// src/pages/Dashboard/NoProjectsView.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../../Stylesheets/Dashboard/NoProjectsView.css';
import WorkerImage from '../../assets/illustration/no-project-illustration.png';

const NoProjectsView = () => {
  return (
    <div className="no-projects-wrapper">
      <div className="no-projects-inner">
        {/* LEFT: Copy */}
        <div className="no-projects-content">
          <span className="no-projects-pill">Welcome to Site360</span>

          <h2 className="no-projects-title">
            Build your first site — let’s get to work 💪
          </h2>

          <p className="no-projects-subtitle">
            Create one project to start tracking labour, materials and expenses in a single dashboard.
          </p>

          <div className="no-projects-steps">
            <div className="no-project-step">
              <span className="no-project-step-badge">1</span>
              <div className="no-project-step-text">
                <h4>Name your project & site</h4>
              </div>
            </div>
            <div className="no-project-step">
              <span className="no-project-step-badge">2</span>
              <div className="no-project-step-text">
                <h4>Add your team & materials</h4>
              </div>
            </div>
            <div className="no-project-step">
              <span className="no-project-step-badge">3</span>
              <div className="no-project-step-text">
                <h4>Start logging daily work</h4>
              </div>
            </div>
          </div>

          <div className="no-projects-cta-row">
            <Link to="/dashboard/create">
              <button className="no-projects-btn">
                + Create New Project
              </button>
            </Link>
            <span className="no-projects-time-hint">
              Takes less than <strong>2 minutes</strong> to set up.
            </span>
          </div>
        </div>

        {/* RIGHT: Illustration + tiny metrics */}
        <div className="no-projects-visual">
          <img
            src={WorkerImage}
            alt="Construction illustration"
            className="no-projects-image"
          />

          <div className="no-projects-mini-metrics">
            <div className="mini-metric-card">
              <span className="mini-metric-label">Active projects</span>
              <span className="mini-metric-value">0</span>
            </div>
            <div className="mini-metric-card">
              <span className="mini-metric-label">Workers tracked</span>
              <span className="mini-metric-value">0</span>
            </div>
            <div className="mini-metric-card">
              <span className="mini-metric-label">Material items</span>
              <span className="mini-metric-value">0</span>
            </div>
          </div>

          <p className="no-projects-footnote">
            These numbers grow as you add projects, labour and materials.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoProjectsView;
